import { z } from "zod";
import {
  ResidencePermitDataSchema,
  ResidencePermitContextSchema,
  ResidencePermitExtractionSchema,
  type ResidencePermitData,
} from "../../../document/document-types/residence-permit";
import type { FieldMessages } from "../../../document/types";
import { createFieldMessagesSchema } from "../../../document/schema";
import { storeResponseSchema } from "../base";
import type { DocumentTypeSchemas } from "../types";

// ===== Internal schemas (not exported) =====

const fieldMessagesSchema = createFieldMessagesSchema(ResidencePermitDataSchema);

const warnRequestSchema = z.object({
  data: ResidencePermitDataSchema.partial(),
  context: ResidencePermitContextSchema,
});

const validateRequestSchema = z.object({
  data: ResidencePermitDataSchema.partial(),
  context: ResidencePermitContextSchema,
});

// ===== Exported types (for API client) =====

/** Response type for /extract endpoint */
export type ExtractResponse = z.infer<typeof ResidencePermitExtractionSchema>;

/** Request body type for /warn endpoint */
export type WarnRequestBody = z.infer<typeof warnRequestSchema>;

/** Response type for /warn endpoint - uses FieldMessages for proper key typing */
export type WarnResponse = FieldMessages<ResidencePermitData>;

/** Request body type for /validate endpoint */
export type ValidateRequestBody = z.infer<typeof validateRequestSchema>;

/** Response type for /validate endpoint - uses FieldMessages for proper key typing */
export type ValidateResponse = FieldMessages<ResidencePermitData>;

/** Response type for /store endpoint */
export type StoreResponse = z.infer<typeof storeResponseSchema>;

// ===== Exported bundle (source of truth for route registration) =====

/**
 * Bundled schemas for route factory registration
 */
export const ResidencePermitSchemas = {
  extractResponse: ResidencePermitExtractionSchema,
  warnRequest: warnRequestSchema,
  warnResponse: fieldMessagesSchema,
  validateRequest: validateRequestSchema,
  validateResponse: fieldMessagesSchema,
  storeResponse: storeResponseSchema,
} satisfies DocumentTypeSchemas;
